import { useLocation as useRouterLocation, useParams, useSearchParams } from 'react-router-dom';

export const useLocation = () => {
  const location = useRouterLocation();
  const parameters = useParams();
  const [searchParameters, setSearchParameters] = useSearchParams();

  return { location, parameters, searchParameters, setSearchParameters };
};
